import { useToggle } from 'modules/utils/useToggle';
import { useCallsSearchFilters } from './usePageParams';
import { LiquidityFilterModal } from './LiquidityFilterModal';
import { MarketcapFilterModal } from './MarketcapFilterModal';
import { FunnelIcon } from '@heroicons/react/24/outline';
import { FilterButton } from '../../../components/filters/filterButton';

export function LiquidityRangeFilter() {
  const [isOpen, { open, close }] = useToggle();
  const { filtersState } = useCallsSearchFilters();

  return (
    <>
      <FilterButton label="Liquidity" onClick={() => open()}>
        {!!(filtersState.minLiquidity || filtersState.maxLiquidity) && (
          <FunnelIcon className="w-3 h-3 xxs:text-dex-white-secondary" />
        )}
      </FilterButton>
      {isOpen && <LiquidityFilterModal handleClose={close} />}
    </>
  );
}

export function MarketcapRangeFilter() {
  const [isOpen, { open, close }] = useToggle();
  const { filtersState } = useCallsSearchFilters();

  return (
    <>
      <FilterButton label="Marketcap" onClick={() => open()}>
        {!!(filtersState.minMarketcap || filtersState.maxMarketcap) && (
          <FunnelIcon className="w-3 h-3 xxs:text-dex-white-secondary" />
        )}
      </FilterButton>
      {isOpen && <MarketcapFilterModal handleClose={close} />}
    </>
  );
}
